module.exports = __webpack_public_path__ + "static/img/add-family-graphic.d8a11e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-family-graphic.svg
// module id = LDfK
// module chunks = 1